module.exports = __webpack_public_path__ + "img/google-petra-05.6740a566.jpg";